import React from 'react';

function Loader(props){
    const {show} = props;
    return (
        show === true ? (
            <div className="overlay">
                <i className="fa fa-refresh fa-spin"></i>
            </div>
        ):(
            <span></span>
        )
    )
}

export default Loader;